import { render, staticRenderFns } from "./Partn.vue?vue&type=template&id=37012a89"
import script from "./Partn.vue?vue&type=script&lang=js"
export * from "./Partn.vue?vue&type=script&lang=js"
import style0 from "./Partn.vue?vue&type=style&index=0&id=37012a89&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports